module.exports = __webpack_public_path__ + "static/media/logo.be8fb3f9.png";